import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme.css';
import App from './App';
import { setupFetchInterceptor } from './config/fetch-interceptor';
import { setupAxiosInterceptor } from './config/axios-interceptor';

// Inject JWT token into all /api/* fetch calls globally
setupFetchInterceptor();
// Inject JWT token into all /api/* axios calls globally
setupAxiosInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


